import type { DeviceLanguage } from '../types/api.types'

export const DEFAULT_DEVICE_LANGUAGE: DeviceLanguage = 'multi'

export const DEVICE_LANGUAGE_OPTIONS: ReadonlyArray<{
  value: DeviceLanguage
  label: string
  badge: string
}> = [
  { value: 'multi', label: 'English + Urdu (mixed)', badge: 'Multi' },
  { value: 'en', label: 'English', badge: 'EN' },
  { value: 'ur', label: 'Urdu', badge: 'UR' },
  { value: 'ar', label: 'Arabic', badge: 'AR' },
]

export function deviceLanguageBadge(value?: string | null): string {
  return DEVICE_LANGUAGE_OPTIONS.find((o) => o.value === value)?.badge ?? 'Multi'
}
